<div class="zn-gis-dashboard">
  <div class="zn-gis-dashboard-header">
    <div class="zn-gis-dashboard-title-container">
      <h1 class="zn-gis-dashboard-title">
        {{ 'Geographic::Entity.GisInconsistencyDashboard.Title' | abpLocalization }}
      </h1>
      <p class="zn-gis-dashboard-description">
        {{ 'Geographic::Entity.GisInconsistencyDashboard.Description' | abpLocalization }}
      </p>
    </div>
  </div>

  <div class="zn-gis-dashboard-grid">
    @for (group of groups(); track group.key) {
      <gis-inconsistency-group-card
        [group]="group"
        (querySelected)="openQuery($event)"
      />
    }
  </div>
</div>